/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMagicWand = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    <path
      fill="#102A43"
      d="M7.054 4.692 4.69 7.054l2.747 2.747L9.801 7.44 7.054 4.692Zm3.542 3.542-2.362 2.362 6.25 6.279 2.391-2.39-6.279-6.251ZM3.938 6.188H1.124v1.125h2.813V6.188Zm-.765-3.811-.796.796 1.99 1.989.795-.796-1.99-1.989Zm4.14-1.252H6.188v2.813h1.125V1.124Zm3.019 1.252-1.989 1.99.796.795 1.989-1.989-.796-.796ZM4.366 8.343l-1.989 1.989.796.795L5.162 9.14l-.796-.796Z"
    />
  </svg>
);

export default SvgMagicWand;
